
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import ApplyCSS from '../../../../../components/ApplyCSS';
import * as getGlobleObject from './../../../../../components/globleObject/reducer';
import * as contractPageActions from './actions';
import commonUtil from '../../../../../utils/commonUtil';
import pdfUtil from '../../../../../utils/PDFUtil';
import * as createEventObject from '../../../../createEvent/actions';
import * as deliveryAddressActions from './../DeliveryAddress/actions';
import { constAPISuccess, constDownload, constPrint } from '../../../../../utils/clientConstant';
import ContractPagDownloadPDF from './contractPageForDownloadPDF';
import DownloadPDFWithoutPreview from '../../../../../components/DownloadPDFWithoutPreview';
import Tagging from '../../../../../components/Tagging/Tagging';
import DownloadPDFWithoutPreviewContract from '../../../../../components/DownloadPDFWithoutPreview/contract';
import { downloadContractIcon } from '../../../../createEvent/page/SelectMesaType/components/svgIcons';

const applicationRoutes = commonUtil.getApplicationRoutes();
const { handleGetEventContractPage } = contractPageActions;
const { getDeliveryAddressInfo } = deliveryAddressActions;
const pageName = 'contract';
const channel = commonUtil.getChannel();


@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
  contractPage: store.contractPage.data,
  globleObj: store.globleObject,
}),
  {
    ...getGlobleObject, ...createEventObject,
  })

class ContractPage extends Component {

  UNSAFE_componentWillMount = () => {
    const user = this.props.user;
    if (!(user && user.result && user.result.status && user.result.status.status === constAPISuccess)) {
      if (browserHistory) {
        browserHistory.push('/');
      }
    }
    const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
    if (eventID) {
      if(this.props.isGiftListContract){
        this.props.handleGetEventContractPage(eventID, this.props.eventType, this.props.eventDate);
      }else{
        this.props.handleGetEventContractPage(eventID);
      }
      
      this.props.getDeliveryAddressInfo(eventID);
    }
  }
  componentDidMount() {
    const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
    const eventUrl = 'gestiondeeventos/Contrato/';

    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'vPageView',
      GroupOne: eventUrl,
      actURL: window.location.pathname,
      actPageTitle: document.title,
      cdSection: 'Contrato',
      Site: 'Mesa de Regalos',
      idMesa: eventID,
    });
  }

  // function for download PDF & print
  downloadToPDF = (param) => {
    const fileName = 'Contrato del evento';
    if (param && param === constDownload) {
      window.open(commonUtil.routeTo(applicationRoutes.downloadToPDF, [{ pageName }, { content: param }, { fileName }]), '_blank', 'scrollbars=yes,width=' + screen.width + ',height=' + screen.height);
    } else if (param && param === constPrint) {
      window.open(commonUtil.routeTo(applicationRoutes.downloadToPDF, [{ pageName }, { content: param }, { fileName }], 'PRINT', '_blank', 'height=400,width=600'));
    }
  }
  getContractDetails = () => {
    let contractDetails = '';
    if (this.props?.contractDetails && this.props?.contractDetails?.contractStaticData && this.props?.contractDetails?.contractStaticData) {
      contractDetails = this.props?.contractDetails?.contractStaticData;
    }
    return contractDetails;
  }

  handlePDFDownload = () => {
    const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : '';
    const contractDetails = this.getContractDetails();
    const downloadableContent = (<DownloadPDFWithoutPreviewContract printingDate={this.props.printingDate} download fileName="contract"><ContractPagDownloadPDF userAllData={this.userAllData} contractDetails={contractDetails} /></DownloadPDFWithoutPreviewContract>);
    pdfUtil.attachToDom(downloadableContent, ('contract_' + eventID));
  }

  handlePrint = () => {
    // const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : '';
    const contractDetails = this.getContractDetails();
    const printContent = (<DownloadPDFWithoutPreview pageName printingDate={this.props.printingDate}><ContractPagDownloadPDF userAllData={this.userAllData} contractDetails={contractDetails} /></DownloadPDFWithoutPreview>);
    // pdfUtil.attachToDom(downloadableContent, this.props.printingDate, ('contract_' + eventID));
    pdfUtil.attachToDomForPrint(printContent, pageName);
  }

  render() {
    const { lables, contractDetails,selectedTheme } = this.props;
    this.userAllData = {
      eventDate: this.props.eventDetailsInfo,
      addresses: this.props.addresses,
    };
    const titleHtml = this.props.isGiftListContract ? `<p class='contract-event-management'>${commonUtil.getLabel(lables.eventDetails, 'eventManagement.contract.title')}</p>` : '';
    return (
      <div>
        <ApplyCSS pageName={pageName} />
        <Tagging ref={tagging => this.tagging = tagging} />
        {channel === 'wap' ?
          <div /* className="col-md-12" */>
            <div className="innerWrap contractWrapper">
              {this.props.isGiftListContract && 
                <div className="download-link-div-tag downloadLinkDiv">
                  <a href="javascript:void(0)" id="downloadLink">
                    {/* <span className="icon-descarga downloadIcon a" onClick={() => this.handlePDFDownload()} /> */}
                     <span className='download-icon-glc multi-download-svg-icon'
                              dangerouslySetInnerHTML={{ __html: downloadContractIcon }} onClick={() => this.handlePDFDownload()}>
                        </span>
                    {/* {<img src={commonUtil.getAssetURL() + '/images/file_download_contract.svg'} alt="file_download" className="download-icon-glc" onClick={() => this.handlePDFDownload()} />}  */}
                  </a>
                </div>
              }
              <div className="row">
                <div className="col-xs-12" id="contract">
                  {!this.props.isGiftListContract && <h1 className="titleSection">Contrato</h1>}
                  {!this.props.isGiftListContract && 
                  <a href="javascript:void(0)" id="downloadLink">
                    <i className="icon-descarga downloadIcon-eventMangement" onClick={() => this.handlePDFDownload()} />
                  </a>}
                  {/* <p className="subtitleModule">{commonUtil.getLabel(lables.eventDetails, 'eventManagement.contract.title')}</p> */}
                  <div className={`pdfContent ${this.props.isGiftListContract && 'pdf-content-glc'}`}>
                    {(contractDetails && contractDetails?.contractStaticData) ?
                      <p className="pdfContentptag" dangerouslySetInnerHTML={{ __html: `${titleHtml} ${contractDetails?.contractStaticData}` }} />
                      :
                      <h4>Data not Available in service</h4>}
                  </div>

                  {this.props.isGiftListContract && 
                  <row>
                    <div id="gift-list-contract-btn" className="buttonBlock margin-top-70">
                      <div className="col-xs-12 col-sm-12 mb-60 step4LeftBtn step4RightBtn">
                        <div className="buttonBlock newButtonBlock">
                          <button
                            className="btnSecondaryAction size-Large btnSecondaryAction size-Full"
                            aria-hidden="false"
                            onClick={this.props.onBackClick}
                            style={{
                              '--color-500': selectedTheme?.color_500 || '#333',
                              border: '1px solid var(--color-500)',
                              color: 'var(--color-500)',
                            }}
                          >
                            Regresar
                          </button>
                        </div>
                      </div>
                    </div>
                  </row>
                  }
                  
                </div>
              </div>
            </div>
          </div>
          :
          <div className={`col-md-12 oppeningContainer ${"container-glc"}`}>
            <h1 className={`titleSection ${this.props.isGiftListContract && 'title-section-glc'}`}>{this.props.isGiftListContract ? "Contrato de Mesa de Regalos" : "Contrato"}</h1>
            {/* <h2 className="subtitleModule">{commonUtil.getLabel(lables.eventDetails, 'eventManagement.contract.title')}</h2> */}
            <div className="innerWrap contractWrapper">
              <div className={`pdfContent ${this.props.isGiftListContract && 'pdf-content-glc one'}`}>
                {!this.props.isGiftListContract && <p className="mainTex">{commonUtil.getLabel(lables.createEventStep4, 'createEventStep4.contract.message')}</p>}
                {contractDetails && contractDetails?.contractStaticData  ?
                  <p className="pdfContentptag" dangerouslySetInnerHTML={{ __html: contractDetails?.contractStaticData }} />
                  :
                  <h4>Data not Available in service</h4>}
              </div>
              <div className="row">
                <div className="col-md-10 termsConditions" />
                <div className="col-md-10 termsConditions" />
                <div className={`col-md-2 buttonsPdf ${this.props.isGiftListContract && 'text-right'}`}>
                  {!this.props.isGiftListContract && <i className="icon-imprimir" onClick={() => this.handlePrint()} />}
                  <a href="javascript:void(0)" >
                      
                       <span className='download-icon-glc multi-download-svg-icon'
                              dangerouslySetInnerHTML={{ __html: downloadContractIcon }} onClick={() => this.handlePDFDownload()}>
                        </span>
                    {/* {<img src={commonUtil.getAssetURL() + '/images/file_download_contract.svg'} alt="file_download" className="download-icon-glc" onClick={() => this.handlePDFDownload()} />} */}
                    {/* <i className={`icon-descarga ${this.props.isGiftListContract && 'lpColor download-icon-glc'}`} onClick={() => this.handlePDFDownload()} /> */}
                    </a>
                </div>
              </div>
            </div>
          </div>
        }
        {/* <div style={{ display: 'none' }}>
          <ContractPagDownloadPDF userAllData={this.userAllData} contractDetails={contractDetails} />
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.data ? state.user.data : null,
  contractDetails: state.contractPage && state.contractPage.data ? state.contractPage.data : null,
  eventDetailsInfo: state.eventDetails.userEventDetails.eventDetailsInfo,
  addresses: state.deliveryAddress.data.deliveryAddressInfo && state.deliveryAddress.data.deliveryAddressInfo.addresses,
  printingDate: state.info && state.info.data && state.info.data.time,
});
const matchDispatchToProps = dispatch => bindActionCreators({ handleGetEventContractPage, getDeliveryAddressInfo }, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(ContractPage);
